import React, { useState } from "react";
import AboutImg1 from "../Img/1.png";
import AboutImg2 from "../Img/2.png";
import AboutImg3 from "../Img/3.png";
import { BadgeCheck, Users, Clock4, Heart } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";


const AboutUs = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const navigate = useNavigate()

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const accordionItems = [
    {
      title: "Mission",
      content:
        "To nurture confident, skilled, and disciplined skaters across India by providing world-class training, mentorship, and competition exposure.",
    },
    {
      title: "Vision",
      content:
        "To become India’s most trusted and result-oriented skating academy, producing athletes who shine nationally and globally.",
    },
    {
      title: "Core Values",
      content:
        "Integrity, perseverance, inclusivity, and a passion for progress — both on and off the rink.",
    },
  ];
  return (
    <div className="rsi-about-container">

      {/* Section 1: Hero */}
      <section className="rsi-hero-section">
        <div className="rsi-hero-content">
          <h1 className="rsi-hero-title">Welcome to Radical Sports India</h1>
          <p className="rsi-hero-subtitle">
            India's premier Roller Skating Academy – where passion turns into performance.
          </p>
          <button className="rsi-hero-button" onClick={() => navigate("/course")}>Explore Our Courses</button>
        </div>
      </section>

      {/* Section 2: Our Story */}
      <section className="rsi-story-section">
        <div className="rsi-story-wrapper">
          <div className="rsi-story-text">
            <h2 className="rsi-section-title">Our Story</h2>
            <p>
              Established in 2014, Radical Sports India began with a mission to revolutionize the skating landscape in India.
              What started as a small coaching center has now grown into a full-fledged academy with a presence in multiple cities.
            </p>
            <p>
              We’re passionate about creating opportunities for every skater — be it children looking for a fun after-school activity or serious athletes aspiring for medals.
              Our philosophy blends discipline, fitness, and confidence to shape champions on and off the rink.
            </p>
            <p>
              With strong community ties, dedicated parents, and passionate coaches, Radical Sports India stands as a beacon of quality skating education in the country.
            </p>
            <div className="rsi-accordion">
              {accordionItems.map((item, index) => (
                <div
                  className={`rsi-accordion-item ${openAccordion === index ? "open" : ""}`}
                  key={index}
                >
                  <div
                    className="rsi-accordion-header"
                    onClick={() => toggleAccordion(index)}
                  >
                    {item.title}
                    <span className="rsi-accordion-icon">
                      {openAccordion === index ? "−" : "+"}
                    </span>
                  </div>

                  <AnimatePresence initial={false}>
                    {openAccordion === index && (
                      <motion.div
                        className="rsi-accordion-wrapper"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
                      >
                        <div className="rsi-accordion-content">
                          {item.content}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>

          </div>
          <div className="rsi-story-images">
            <img src={AboutImg1} alt="Skating Academy" className="rsi-story-img" />
          </div>
        </div>
      </section>

      {/* Section 3: Why Choose Us */}
      <section className="rsi-features-section">
        <h2 className="rsi-section-title">Why Choose Radical Sports?</h2>
        <ul className="rsi-features-list">
          <li><BadgeCheck className="rsi-icon" /> National-level certified coaches</li>
          <li><Users className="rsi-icon" /> 5000+ trained skaters across India</li>
          <li><Clock4 className="rsi-icon" /> Flexible weekday & weekend batches</li>
          <li><Heart className="rsi-icon" /> Safe, fun & fitness-focused training</li>
          <li><BadgeCheck className="rsi-icon" /> Regular state & district level competition exposure</li>
          <li><Users className="rsi-icon" /> Personalized attention with small batch sizes</li>
        </ul>

      </section>
      {/* Section 5: Testimonials */}
      <section className="rsi-testimonials-section">
        <h2 className="rsi-section-title">What Our Skaters Say</h2>
        <div className="rsi-testimonial-grid">
          <div className="rsi-testimonial-card">
            <p>
              "Radical Sports helped my son gain confidence, discipline, and medals! Best skating academy hands down."
            </p>
            <span className="rsi-testimonial-name">– Renu Shah, Parent</span>
          </div>
          <div className="rsi-testimonial-card">
            <p>
              "From a beginner to state-level medals, Radical Sports guided me every step of the way. Thank you coaches!"
            </p>
            <span className="rsi-testimonial-name">– Kabir Jain, Skater</span>
          </div>
          <div className="rsi-testimonial-card">
            <p>
              "The trainers here are incredibly supportive. I’ve not only improved my skating but also my confidence and focus."
            </p>
            <span className="rsi-testimonial-name">– Diya Mehta, Student</span>
          </div>
        </div>
      </section>

      {/* Section 6: Call to Action */}
      <section className="rsi-cta-section">
        <h2 className="rsi-cta-title">Ready to Begin Your Skating Journey?</h2>
        <p className="rsi-cta-subtitle">
          Join Radical Sports India and experience the thrill of skating in a supportive and fun environment.
        </p>
        <button className="rsi-cta-button" onClick={() => navigate("/admission-form")}>Join Now</button>
      </section>

    </div>
  );
};

export default AboutUs;
